import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, GlobeIcon } from 'lucide-react';
import { guarantees } from '../data/content';
const icons = [ShieldCheckIcon, LockIcon, ZapIcon, GlobeIcon];
export function TopBar() {
  return <div className="w-full bg-plum-700" data-id="element-156" data-mp="1y4lojesuuocy">
      <div className="mx-auto flex max-w-content flex-wrap items-center justify-center gap-x-6 gap-y-2 px-5 py-2.5" data-id="element-157" data-mp="1y5n9cazoap7v">
        {guarantees.map((item, index) => {
        const Icon = icons[index];
        return <span key={item} className="inline-flex shrink-0 items-center gap-2 text-[11px] font-medium uppercase tracking-[0.14em] text-cream-100 sm:text-xs" data-id="element-158" data-mp="2ltmxd35lo1ir" data-mpi={index}>
              <Icon aria-hidden="true" className="h-3.5 w-3.5 text-rose-300" data-id="element-159" data-mp="2c43h8599ulrl" />
              {item}
            </span>;
      })}
      </div>
    </div>;
}